import MailingAddress from '@App/kit/fields/v2/MailingAddress'
import React from 'react'
import { FormFieldType } from '@App/forms/v2/common/form-field'
import { AddressType } from '@Entities/schemas/common/address-schema'

interface AddressSectionProps {
    addressForm: FormFieldType<AddressType>
}

const AddressSection = (props: AddressSectionProps) => {
    const { addressForm } = props
    return (
        <section className="address-section">
            <h5>Address</h5>
            <div className="fields-row-container">
                <MailingAddress addressFormFields={addressForm} />
            </div>
        </section>
    )
}
export default AddressSection
